module.exports = __webpack_public_path__ + "img/screen-agrupador-03.c75cd57b.png";